/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useMemo, useCallback } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter, NavLink, useHistory } from "react-router-dom";
import { Dropdown, Menu } from "antd";
import { pathOr, propOr } from "ramda";
import Cookies from "universal-cookie";
import { If, Then, Else } from "react-if";
import axios from "axios";
import * as Yup from "yup";
import moment from "moment";

import {
  CERNER_EHR_WHITELABEL,
  LIVECHAT_DOMAIN,
  PRACTICE_EDITION_WHITELABEL,
  TOKEN_NAMES,
  VERADIGM_EHR_WHITELABEL,
} from "../../constants/constants";
import loginService from "../../service/login";
import {
  checkUserExist,
  emptyReducerAction,
  LoginSagaAction,
  notificationCountAction,
  PatientCountAction,
  activePatientSagaAction,
  liveAgentChatCountAction,
  liveAgentChatSagaAction,
} from "../../sagas/saga-actions";
import { setPopup } from "../../actions/popupAction";
import { setUnread } from "../../actions/unreadAction";
import { setNotificationAlert } from "../../actions/notificationAlertAction";
import CustomNotification from "../notification";
import { getTokenExpiry } from "../../helper/helpers";
import {
  mobileOptionsMenu,
  urls,
  hcpPortalUrlRegex,
  NEXTGEN_EHR_WHITELABEL,
  EPIC_EHR_WHITELABEL,
  IDLE_TIMEOUT,
} from "../../constants/constants";
import TelevoxLogo from "../../images/logos/televox-housecalls-pro-logo.svg";
import NextgenLogo from "../../images/logos/nextgen-logo.png";
import CernerLogo from "../../images/logos/cerner-logo.png";
import VeradigmLoginLogo from "../../images/login/veradigm-login-logo.png";
import PracticeEditionLogo from "../../images/logos/practiceEdition/practice-edition-logo-televox.png";
import { ArrowDown, HelpLinkSvg, MenuIcon, SmallArrow } from "../../assets/svg";
import "./styles.scss";
import CustomModal from "../customModal";
import { Form, Formik } from "formik";
import { SingleFormikSelect } from "../select/singleSelect";
import UserService from "../../service/UserService";
import NotificatonPopover from "../notificationPopover";
import {
  BackArrowButton,
  CloseWhiteIcon,
  EditIconDarkBig,
  LockIcon,
  MobileDeleteIcon,
  QuestionCircle,
} from "../../assets/svg/mobileIcon";
import { useIdleTimer } from "react-idle-timer";
import SessionExpireModal from "./SessionExpireModal";
import PortalNotifications from "../portalNotifications";
import { usePortalNotifications } from "../portalNotifications/usePortalNotifications";

const userservice = new UserService();
const PORTAL_BANNER_OFFSET = "4rem";
const Header = (props) => {
  const cookies = new Cookies();
  const bannerOffsetRef = React.useRef(null);
  const currentPath = props.history?.location?.pathname || "";
  const pathAliases = [
    currentPath,
    currentPath.startsWith("/chat") ? "/livechat" : "",
    currentPath.startsWith("/livechat") ? "/chat" : "",
    currentPath.startsWith("/chat-agent") ? "/liveagent" : "",
    currentPath.startsWith("/liveagent") ? "/chat-agent" : "",
  ].filter(Boolean);

  const history = useHistory();

  const {
    user,
    showLogo = true,
    showNotifications = true,
    showHelp = true,
    showAccountDetails = true,
    backgroundColor = "",
    showBackButton = false,
    showPageTitle = false,
    pageTitle = "",
    handleBackButton,
    showEditIcon = false,
    handleEditIcon,
    showDeleteIcon = false,
    showCloseIcon = false,
    handleDelete,
    showMenuIcon = false,
    transferNumber = null,
    releaseNumber = null,
    showSecureChat = false,
  } = props;
  const {
    banners,
    notifications,
    dismissBanner,
    dismissPopup,
  } = usePortalNotifications({
    pathAliases,
    practiceId: loginService.getPracticeId?.(),
    storageKey: `notifications-${loginService.getPracticeId?.() || "private"}`,
  });
  const { customPopupMessage, messageType, message } = props.popupReducer;

  const liveChatPermission = user && user.liveChatAccess;
  const broadcastPermission = user && user.broadcastAccess;
  const liveAgentPermission = user && user.liveAgentAccess;
  const reportOnlyAccess = user && user.reportOnlyAccess;
  const mainOrSub = user?.mainOrSub;
  const { notificationAlert } = props.notificationAlert;
  const roleKey = loginService?.getRoleKey() || "";

  const timeout =
    parseInt(user.practice?.idleTimeoutDuration) ||
    IDLE_TIMEOUT.IDLE_DURATION_IN_MINUTES;
  const promptTimeout =
    parseInt(user.practice?.warningBeforeDuration) ||
    IDLE_TIMEOUT.WARNING_BEFORE_IN_MINUTES;

  const timeoutInMS = timeout * 60 * 1000;
  const promptTimeoutInMS = promptTimeout * 60 * 1000;

  const [state, setState] = useState({
    logout: false,
    triggered: false,
    restrictFlag: false,
    helpLink: "",
    username: "",
    email: "",
    accountName: "",
    switchAccountsModal: false,
    switchDepartmentsModal: false,
    initialValuesChangeAccounts: {
      accountName: "",
      userName: "",
    },
    initialValuesChangeDepartments: {
      subAccountName: "",
      deptName: "",
    },
    accountsList: [],
    userList: [],
    subAccountList: [],
    deptList: [],
    shiftStart: "",
    shiftEnd: "",
    awayMessage: "",
    warningVisible: false,
  });

  const formSchema = Yup.object().shape({
    accountName: Yup.object().shape({
      id: Yup.string().required("Account name is required"),
    }),
    userName: Yup.object().shape({
      id: Yup.string().required("User name is required"),
    }),
  });

  const changeDepartmentSchema = Yup.object().shape({
    subAccountName:
      (mainOrSub === "1" || roleKey === "CA") &&
      Yup.object().shape({
        id: Yup.string().required("Sub Account name is required"),
      }),
    deptName: Yup.object().shape({
      id: Yup.string().required("Department name is required"),
    }),
  });

  const setValues = async () => {
    const username = loginService.getName();
    const email = loginService.getEmail();
    const accountName = loginService.getAccountName();
    const shiftTimings = await userservice.getShiftTimings();
    const awayMessage = shiftTimings?.contactRulesType;
    const startShift = shiftTimings?.workflowShiftStart;
    const shiftEnd = shiftTimings?.workflowShiftStop;
    setState((st) => ({
      ...st,
      username,
      email,
      accountName,
      shiftStart: startShift
        ? moment(startShift, "HH:mm")?.format("hh:mmA")
        : "NA",
      shiftEnd: shiftEnd ? moment(shiftEnd, "HH:mm")?.format("hh:mmA") : "NA",
      awayMessage,
    }));
  };

  useEffect(() => {
    setValues();
    window.addEventListener(
      "syncNotificationCount",
      (e) => {
        props.NotificationCount();
      },
      false
    );
  }, []);

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--portal-banner-offset",
      banners.length ? PORTAL_BANNER_OFFSET : "0px"
    );

    return () => {
      document.documentElement.style.setProperty("--portal-banner-offset", "0px");
    };
  }, [banners.length]);

  const logOut = async () => {
     if (localStorage.getItem('isLoggingOut')) return; 
  localStorage.setItem('isLoggingOut', 'true');
  try {
    await userservice.logoutApi('manual');
  } finally {
    localStorage.removeItem('isLoggingOut');
    loginService.Logout();
    setState((st) => ({
      ...st,
      logout: true,
      triggered: true,
    }));
    if (
      cookies.get("logoutFlag", {
       path: "/", 
       sameSite: "none", 
       secure: true }) || 
      localStorage.getItem("logoutFlag")
    ) {
      window.location.href = "/logout";
    } else {
      window.location.href = "/login";
    }
  }
};

  const handleOnIdle = async () => {
    if (localStorage.getItem('isLoggingOut')) return; 
  localStorage.setItem('isLoggingOut', 'true'); 
  try {
    await userservice.logoutApi('timeout'); 
  } catch (error) {
    console.error("Error logging out on timeout:", error);
  } finally {
     localStorage.removeItem('isLoggingOut'); 
    loginService.Logout();
    setState((st) => ({
      ...st,
      logout: true,
      triggered: true,
      warningVisible: false,
    }));
    history.push("/login");
  }
};

 const onIdle = () => {
  handleOnIdle();
};

  const onActive = () => {
    if (state.warningVisible) {
      setState((st) => ({
        ...st,
        warningVisible: false,
      }));
    }
  };
  const onPrompt = () => {
    setState((st) => ({
      ...st,
      warningVisible: true,
    }));
  };

  const handleStillHere = () => {
    activate();
  };

  const { getRemainingTime, activate } = useIdleTimer({
    timeout: timeoutInMS - promptTimeoutInMS,
    promptTimeout: promptTimeoutInMS,
    onActive,
    onIdle,
    onPrompt,
    syncTimers: 500,
    leaderElection: true,
    crossTab: true,
    events: [
      "mousemove",
      "keydown",
      "wheel",
      "DOMMouseScroll",
      "mousewheel",
      "mousedown",
      "touchstart",
      "touchmove",
      "MSPointerDown",
      "MSPointerMove",
    ],
  });

  const getLogo = () => {
    if (NEXTGEN_EHR_WHITELABEL) {
      return NextgenLogo;
    } else if (CERNER_EHR_WHITELABEL) {
      return CernerLogo;
    } else if (PRACTICE_EDITION_WHITELABEL) {
      return PracticeEditionLogo;
    } else if (VERADIGM_EHR_WHITELABEL) {
      return VeradigmLoginLogo;
    } else {
      return TelevoxLogo;
    }
  };

  const setNotificationBadge = (data) => {
    const id = data?.practiceId;
    const userId = props?.user?.practiceId;
    if (userId === id) {
      props.setUnread({ unreadMessage: data.notificationBadgeShow });
    }
  };

  const refreshAfterTransfer = (type) => {
    const pathname = window.location.pathname;
    if (pathname === "/chat" && type === "0") {
      props.PatientCount();
      if (user?.id) {
        const obj = {
          offset: 0,
          userId: user.id,
        };
        props.activePatientSagaAction(obj);
      }
    } else if (pathname === "/chat-agent" && type === "1") {
      props.liveAgentChatCount();
      if (user?.id) {
        const obj = {
          offset: 0,
          active: 1,
        };
        props.liveAgentChatSaga(obj);
      }
    } else return;
  };

  const setNotificationAlert = (data) => {
    const { user } = props;
    const practiceIdReceived = data?.practiceId;
    const userIdReceived = data?.userId;
    const practiceId = user?.practiceId;
    const userId = ["OU", "TS"].includes(user?.roles?.roleKey)
      ? props?.user?.lcUser?.id
      : props?.user?.id;
    if (practiceIdReceived === practiceId && userIdReceived === userId) {
      props.setNotificationAlert({
        notificationAlert: data.notificationBadgeShow,
      });
      if (data.notificationBadgeShow) {
        refreshAfterTransfer(data.type);
      }
    }
  };

  const ChangeUrl = () => {
    var now = new Date();
    var time = now.getTime();
    time += 3600 * 1000;
    now.setTime(time);
    // to do add more secure values
    const hostname = window.location.hostname;
    if (hostname.includes("myhousecallspro")) {
      cookies.set("referrer-portal", "bbD2Ov97EXC5Rd7AmXQACFSxv99MU4m4", {
        path: "/",
        domain: LIVECHAT_DOMAIN,
        expires: now,
      });

      setState((st) => ({
        ...st,
        helpLink: "https://docs-v2.myhousecallspro.com",
      }));
    } else {
      cookies.set("referrer-portal", "bbD2Ov97EXC5Rd7AmXQACFSxv99MU4m4", {
        path: "/",
        domain: ".simplify.health",
        expires: now,
      });

      setState((st) => ({
        ...st,
        helpLink: "https://docs.simplify.health",
      }));
    }
  };

  const getUrl = (liveChatPermission, liveAgentPermission) => {
    if (liveChatPermission) {
      return "/chat";
    } else if (liveAgentPermission) {
      return "/chat-agent";
    } else {
      return "/broadcast";
    }
  };

  useEffect(() => {
    const { logout } = state;

    const isLoggedIn = loginService.isLoggedin();

    if (logout || !isLoggedIn) {
      history.push("/");
    }

    const restrictFlag = loginService.getUserRestriction();

    setState((st) => ({
      ...st,
      restrictFlag,
    }));

    ChangeUrl();

    let cookieExpireTimeout;

    // Handle cookie change or delete
    const handleCookieMaxAge = () => {
      const cookieExpiry = getTokenExpiry();

      if (cookieExpireTimeout) {
        clearTimeout(cookieExpireTimeout);
      }

      if (cookieExpiry) {
        const timeLeft = cookieExpiry - new Date().getTime();
        cookieExpireTimeout = setTimeout(() => {
          logOut();
        }, timeLeft);
      }
    };
    const cookieChangeListener = (cookie) => {
      const domain = pathOr("", ["options", "domain"], cookie);
      if (cookie.name === TOKEN_NAMES.FE && domain !== LIVECHAT_DOMAIN) {
        if (!cookie.value) {
          if (localStorage.getItem('isLoggingOut')) return;
          logOut();
        } else {
          handleCookieMaxAge();
        }
      }
    };
    cookies.addChangeListener(cookieChangeListener);
    handleCookieMaxAge();

    const interceptorId = axios.interceptors.response.use(
      (res) => {
        if (res.config.url.includes(urls.aspariaBackend) && res.headers.token) {
          loginService.updateToken(res.headers.token);
        }

        return res;
      },
      (error) => {
        const status = pathOr(-1, ["response", "status"], error);
        if (status === 401) {
          setTimeout(() => {
            logOut();
          }, 1000);
        }
        return Promise.reject(error);
      }
    );

    setState((st) => ({
      ...st,
      interceptorId,
    }));
    props.NotificationCount();
    window.addEventListener(
      "lcAgentNotificationBadge",
      (e) => {
        const data = e.detail.msg;
        setNotificationBadge(data);
      },
      false
    );

    window.addEventListener(
      "notificationAlert",
      (e) => {
        const data = e.detail.msg;
        setNotificationAlert(data);
      },
      false
    );

    return () => {
      axios.interceptors.response.eject(state.interceptorId);
    };
  }, []);

  const initials = useMemo(
    () => {
      const [firstName = "", lastName = ""] = state?.username?.split(" ") || [];
      return `${propOr("", 0, firstName)}${propOr("", 0, lastName)}`;
    },
    [state.username]
  );

  const fetchAccounts = (page = 1, searchQuery, isScrolling) => {
    return new Promise(async (resolve, reject) => {
      try {
        const {
          rows: accountsList = [],
          count = 0,
        } = await userservice.getPortalAccountsForAdmin(page, searchQuery, 15);
        setState((st) => ({
          ...st,
          accountsList: isScrolling
            ? [...st.accountsList, ...accountsList]
            : accountsList,
        }));
        resolve(count);
      } catch (err) {
        reject(err);
      }
    });
  };

  const handleChangeAccount = async (values, e) => {
    e.preventDefault();
    try {
      const response = await userservice.loginWithAdmin(values?.id);
      const { userDetails } = response;
      const mainOrSub = userDetails?.lcUser?.mainOrSub;
      const role = userDetails?.lcUser?.roles?.roleKey;
      if (userDetails?.isConfig && !userDetails?.directLoginLC) {
        setState((st) => ({ ...st, switchAccountsModal: false }));
        history.push({
          pathname: "/login-by-dept",
          state: {
            mainOrSub,
            role,
            roleType: userDetails?.roleType,
          },
        });
      } else {
        if (!userDetails.practiceId) {
          props.setPopup({
            customPopupMessage: true,
            messageType: "error",
            message: `Invalid credentials handleChangeAccount!`,
          });
          return;
        }
        loginService.doAdminLogin(response?.userDetails, "", "");
        props.LoginSagaAction(userDetails);
        setState((st) => ({ ...st, switchAccountsModal: false }));
        props.setPopup({
          customPopupMessage: true,
          messageType: "success",
          message: `Account successfully changed to ${
            userDetails?.lcUser?.username
          }`,
        });
      }
    } catch (err) {
      props.setPopup({
        customPopupMessage: true,
        message: pathOr(
          "Internal Server Error. Please check the connection",
          ["response", "data", "message"],
          err
        ),
        messageType: "error",
      });
    }
  };

  const handleChangeDepartment = async (values, e) => {
    e.preventDefault();
    try {
      const obj =
        mainOrSub === "0" && ["CR", "CL"].includes(roleKey)
          ? {
              department: values?.deptName?.id,
            }
          : {
              account: values?.subAccountName?.id,
              department: values?.deptName?.id,
            };
      const response = await userservice.loginWithDept(obj);
      const { userDetails } = response.data;
      if (!userDetails.practiceId) {
        setState((st) => ({ ...st, switchDepartmentsModal: false }));
        props.setPopup({
          customPopupMessage: true,
          messageType: "error",
          message: `Invalid credentials!`,
        });
        return;
      }
      if (userDetails?.lcUser) {
        loginService.doAdminLogin(userDetails, "", "");
      } else {
        loginService.doLogin(userDetails, "", "");
      }
      props.LoginSagaAction(userDetails);
      setState((st) => ({ ...st, switchDepartmentsModal: false }));

      props.setPopup({
        customPopupMessage: true,
        messageType: "success",
        message: `Department successfully changed`,
      });

      const { liveChatAccess, broadcastAccess, liveAgentAccess } = userDetails;
      if (liveChatAccess) {
        history.push("/chat");
      } else if (liveAgentAccess) {
        history.push("/chat-agent");
      } else if (broadcastAccess) {
        history.push("/broadcast");
      } else {
        loginService.Logout();
        props.setPopup({
          customPopupMessage: true,
          message: "You do not have access",
          messageType: "error",
        });
        history.push("/login");
      }
    } catch (err) {
      props.setPopup({
        customPopupMessage: true,
        message: pathOr(
          "Internal Server Error. Please check the connection",
          ["response", "data", "message"],
          err
        ),
        messageType: "error",
      });
    }
  };

  const subAccountOptions = [
    {
      id: "all",
      name: "All",
    },
    {
      id: "main",
      name: "Main",
    },
  ];

  const fetchSubAccounts = (page = 1, searchQuery, isScrolling) => {
    return new Promise(async (resolve, reject) => {
      if (!(mainOrSub === "0" && ["CR", "CL"].includes(roleKey))) {
        try {
          let {
            rows: subAccountList = [],
            count = 0,
          } = await userservice.getSubAccounts(page, searchQuery);

          if (roleKey === "CA") {
            subAccountList = [...subAccountOptions, ...subAccountList];
          }
          setState((st) => ({
            ...st,
            subAccountList: isScrolling
              ? [...st.subAccountList, ...subAccountList]
              : subAccountList,
          }));
          resolve(count);
        } catch (err) {
          reject(err);
          props.setPopup({
            customPopupMessage: true,
            message: pathOr(
              "Internal Server Error. Please check the connection",
              ["response", "data", "message"],
              err
            ),
            messageType: "error",
          });
        }
      } else {
        resolve(0);
      }
    });
  };

  const shouldShowNotificationIcon = () => {
    const permissionForPaths = {
      "/broadcast": broadcastPermission,
      "/broadcast/report": broadcastPermission,
      "/chat": liveChatPermission,
      "/chat-agent": liveAgentPermission,
      "/chat/report": liveChatPermission,
    };
    const currentPath = props.history?.location?.pathname;
    return !!(showNotifications && permissionForPaths[currentPath]);
  };

  const handleSSO = async () => {
    try {
      const response = await userservice.SSOLogin();
      if (response.url.match(hcpPortalUrlRegex)) {
        /* eslint-disable-next-line security/detect-non-literal-fs-filename */
        window.open(`${response.url}${response.token}`); // nosemgrep: eslint.detect-non-literal-fs-filename
      } else {
        throw new Error("Invalid URL for SSO");
      }
    } catch (err) {
      props.setPopup({
        customPopupMessage: true,
        message: pathOr(
          "Internal Server Error. Please check the connection",
          ["response", "data", "message"],
          err
        ),
        messageType: "error",
      });
    }
  };
  return (
    <>
      {state.warningVisible && (
        <SessionExpireModal
          handleStillHere={handleStillHere}
          getRemainingTime={getRemainingTime}
          isPrompted={state.warningVisible}
        />
      )}
      {state.switchAccountsModal && (
        <Formik
          enableReinitialize
          initialValues={state?.initialValuesChangeAccounts}
          validationSchema={formSchema}
          validateOnMount
        >
          {({ values, isValid, setFieldValue, validateForm, errors }) => {
            const fetchUsers = (page = 1, searchQuery, isScrolling) => {
              const { practiceId } = values?.accountName || {};
              return new Promise(async (resolve, reject) => {
                if (practiceId) {
                  try {
                    const {
                      rows: userList = [],
                      count = 0,
                    } = await userservice.getPortalUsersForAdmin(
                      practiceId,
                      page,
                      searchQuery
                    );
                    setState((st) => ({
                      ...st,
                      userList: isScrolling
                        ? [...st.userList, ...userList]
                        : userList,
                    }));
                    resolve(count);
                  } catch (err) {
                    reject(err);
                  }
                } else {
                  resolve([]);
                  setFieldValue("userName", {});
                  setState((st) => ({
                    ...st,
                    userList: [],
                  }));
                }
              });
            };
            return (
              <CustomModal
                title="Change Account"
                submitButtonText="Change"
                cancelButtonText="Cancel"
                handleDelete={(e) => handleChangeAccount(values.userName, e)}
                handleCancel={() =>
                  setState((st) => ({ ...st, switchAccountsModal: false }))
                }
                isVisible={state.switchAccountsModal}
                disabled={!isValid}
                customClass="change-account-modal"
              >
                <Form className="fields-wrapper">
                  <section className="form-row">
                    <SingleFormikSelect
                      data={state.accountsList}
                      name="accountName"
                      onChange={() => {
                        setTimeout(validateForm, 0);
                        setFieldValue("userName", {});
                        setState((st) => ({
                          ...st,
                          deptList: [],
                        }));
                      }}
                      optionLabelProp="name"
                      optionValueProp="id"
                      placeholder="Select account name"
                      required
                      title="Account Name"
                      infiniteScroll
                      loadMoreData={fetchAccounts}
                    />
                  </section>
                  <section className="form-row">
                    <SingleFormikSelect
                      data={state.userList}
                      name="userName"
                      key={values.accountName?.practiceId}
                      onChange={() => setTimeout(validateForm, 0)}
                      optionLabelProp="username"
                      optionValueProp="id"
                      placeholder="Select user name"
                      required
                      title="User Name"
                      infiniteScroll
                      loadMoreData={fetchUsers}
                    />
                  </section>
                </Form>
              </CustomModal>
            );
          }}
        </Formik>
      )}

      {state.switchDepartmentsModal && (
        <Formik
          enableReinitialize
          initialValues={state?.initialValuesChangeDepartments}
          validationSchema={changeDepartmentSchema}
          validateOnMount
        >
          {({ values, isValid, setFieldValue, validateForm, errors }) => {
            const fetchDepartments = (page = 1, searchQuery, isScrolling) => {
              const { id } = values?.subAccountName || {};
              return new Promise(async (resolve, reject) => {
                if (
                  id ||
                  (mainOrSub === "0" && ["CR", "CL"].includes(roleKey))
                ) {
                  try {
                    const {
                      rows: departments = [],
                      count: deptCount = 0,
                    } = await userservice.getDepartments(id, page, searchQuery);
                    const deptList = departments.filter((dept) => {
                      return dept.id !== user.department;
                    });
                    setState((st) => ({
                      ...st,
                      deptList: isScrolling
                        ? [...st.deptList, ...deptList]
                        : deptList,
                    }));
                    resolve(deptCount);
                  } catch (err) {
                    reject(err);
                    props.setPopup({
                      customPopupMessage: true,
                      message: pathOr(
                        "Internal Server Error. Please check the connection",
                        ["response", "data", "message"],
                        err
                      ),
                      messageType: "error",
                    });
                  }
                } else {
                  resolve(0);
                  setFieldValue("deptName", {});
                  setState((st) => ({
                    ...st,
                    userList: [],
                  }));
                }
              });
            };
            return (
              <CustomModal
                title="Change Department"
                submitButtonText="Change"
                cancelButtonText="Cancel"
                handleDelete={(e) => handleChangeDepartment(values, e)}
                handleCancel={() =>
                  setState((st) => ({ ...st, switchDepartmentsModal: false }))
                }
                isVisible={state.switchDepartmentsModal}
                disabled={!isValid}
                customClass="change-account-modal"
              >
                <Form className="fields-wrapper">
                  <section className="form-row">
                    <SingleFormikSelect
                      data={state.subAccountList}
                      name="subAccountName"
                      onChange={() => {
                        setTimeout(validateForm, 0);
                        setFieldValue("deptName", {});
                      }}
                      optionLabelProp="name"
                      optionValueProp="id"
                      placeholder={
                        mainOrSub === "0" && ["CR", "CL"].includes(roleKey)
                          ? "Main Account"
                          : "Select sub account name"
                      }
                      required
                      title="Sub Account Name"
                      infiniteScroll
                      loadMoreData={fetchSubAccounts}
                      disabled={
                        mainOrSub === "0" && ["CR", "CL"].includes(roleKey)
                          ? true
                          : false
                      }
                    />
                  </section>
                  <section className="form-row">
                    <SingleFormikSelect
                      data={state.deptList}
                      name="deptName"
                      key={values.subAccountName?.id}
                      onChange={() => setTimeout(validateForm, 0)}
                      optionLabelProp="name"
                      optionValueProp="id"
                      placeholder="Select department name"
                      required
                      title="Department Name"
                      infiniteScroll
                      loadMoreData={fetchDepartments}
                    />
                  </section>
                </Form>
              </CustomModal>
            );
          }}
        </Formik>
      )}

      {customPopupMessage && (
        <CustomNotification messageType={messageType} message={message} />
      )}

      <div ref={bannerOffsetRef} className="portal-banner-shell">
        <PortalNotifications
          banners={banners}
          notifications={notifications}
          onDismissBanner={dismissBanner}
          onDismissNotification={dismissPopup}
        />
      </div>
      <nav className={`app-main-navbar ${backgroundColor}`}>
        <section className="navbar-wrapper">
          <section className="logo-with-tabs-wrapper">
            {showLogo && (
              <figure className="navbar-branding">
                <NavLink
                  to={() => getUrl(liveChatPermission, liveAgentPermission)}
                >
                  <img
                    className="main-logo"
                    id="main-logo"
                    src={getLogo()}
                    alt="Televox"
                  />
                </NavLink>
              </figure>
            )}
            {showBackButton && (
              <span onClick={handleBackButton}>
                <BackArrowButton
                  color={backgroundColor === "black-bg" ? "white" : "dark"}
                />
              </span>
            )}
            {showCloseIcon && (
              <span onClick={handleBackButton}>
                <CloseWhiteIcon
                  color={
                    backgroundColor === "black-bg" ||
                    backgroundColor === "blue-bg"
                      ? "white"
                      : "dark"
                  }
                />
              </span>
            )}
            {showPageTitle && (
              <span
                className={
                  backgroundColor === "black-bg" ||
                  backgroundColor === "blue-bg"
                    ? "page-title color-white"
                    : "page-title"
                }
              >
                {pageTitle}{" "}
                {showSecureChat && (
                  <span className="lock-icon">
                    <LockIcon />
                  </span>
                )}
              </span>
            )}
            {showEditIcon && (
              <span className="edit-icon" onClick={handleEditIcon}>
                <EditIconDarkBig />
              </span>
            )}
            {showMenuIcon && (
              <span className="options-icon" onClick={handleEditIcon}>
                <Dropdown
                  overlayClassName="custom-icons-dropdown"
                  overlay={() =>
                    mobileOptionsMenu(transferNumber, releaseNumber)
                  }
                  trigger={["click"]}
                  placement="topRight"
                  //disabled={!messages.length > 0 ? true : false}
                >
                  <div className="menu-icon">
                    <MenuIcon />
                  </div>
                </Dropdown>
              </span>
            )}
            {showDeleteIcon && (
              <span className="edit-icon" onClick={handleDelete}>
                <MobileDeleteIcon />
              </span>
            )}
            <article className="navbar-tabs">
           
              <If condition={liveChatPermission || reportOnlyAccess}>
                <Then>
                  <NavLink to="/chat" className="tab">
                    Live Chat
                  </NavLink>
                </Then>
                <Else>{null}</Else>
              </If>

              {/* <If condition={liveAgentPermission}>
                <Then>
                  <NavLink to="/chat-agent" className="tab">
                    <span
                      className={`${
                        unreadMessage === true ? "notification-icon" : ""
                      }`}
                    />
                    Live Agent
                  </NavLink>
                </Then>
                <Else>{null}</Else>
              </If> */}

              <If condition={broadcastPermission || reportOnlyAccess}>
                <Then>
                  <NavLink to="/broadcast" className="tab">
                    Broadcast
                  </NavLink>
                </Then>
                <Else>{null}</Else>
              </If>
              <If condition={liveChatPermission || broadcastPermission}>
                <Then>
                  <NavLink to="/logs" className="tab">
                    Logs
                  </NavLink>
                </Then>
                <Else>{null}</Else>
              </If>
            </article>
          </section>
          <section className="navbar-buttons-group">
            {shouldShowNotificationIcon() && (
              <NotificatonPopover notificationAlert={notificationAlert} />
            )}
            {EPIC_EHR_WHITELABEL && (
              <>
                <span className="divider" />
                {showHelp && (
                  <>
                    <a
                      className="help-mob-icon"
                      href={state.helpLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {<QuestionCircle />}
                    </a>
                    <a
                      className="help-link-icon"
                      href={state.helpLink}
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                    >
                      <HelpLinkSvg />
                      <span className="help-text">Help & Support</span>
                    </a>
                  </>
                )}
              </>
            )}
            {showAccountDetails && (
              <>
                <span className="divider" />
                <Dropdown
                  className="navitem-user"
                  trigger={["click"]}
                  overlay={
                    <Menu className="nav-user-menu">
                      <Menu.Item key="0" className="nav-item-dropdown ">
                        <div className="profile-menu">
                          <div className="user-details">
                            <div className="profile-button">
                              <div className="user-initials">{initials}</div>
                            </div>
                            <div>
                              <div title={state.username} className="user-name">
                                <strong>{state.username}</strong>
                              </div>
                              <div title={state.email} className="user-name">
                                {state.email}
                              </div>
                              {roleKey !== "OU" &&
                                roleKey !== "TS" && (
                                  <div>{state.accountName}</div>
                                )}
                            </div>
                          </div>
                        </div>
                      </Menu.Item>
                      <Menu.Item key="1" className="nav-item-dropdown">
                        <div className="profile-option" onClick={handleSSO}>
                          <span>
                            Switch to{" "}
                            {NEXTGEN_EHR_WHITELABEL
                              ? "Nextgen Portal"
                              : VERADIGM_EHR_WHITELABEL
                                ? "veradigm Portal"
                                : "Housecalls Pro"}{" "}
                            <SmallArrow />
                          </span>
                        </div>
                      </Menu.Item>
                      <Menu.Item key="1" className="nav-item-dropdown">
                        <div className="away-message">
                          <span>Away Message</span>
                          <span className="small-text">
                            {state?.awayMessage}
                          </span>
                        </div>
                      </Menu.Item>
                      <Menu.Item key="1" className="nav-item-dropdown">
                        <div className="away-message">
                          <span>Shift Timings</span>

                          <span className="small-text">
                            {state?.shiftStart + ` - ` + state?.shiftEnd}
                          </span>
                        </div>
                      </Menu.Item>
                      <Menu.Item key="2" className="nav-item-dropdown">
                        <NavLink to="/profile">Profile Settings</NavLink>
                      </Menu.Item>
                      {!props?.user?.isConfig &&
                        (roleKey === "OU" || roleKey === "TS") && (
                          <Menu.Item
                            key="3"
                            className="nav-item-dropdown"
                            onClick={() =>
                              setState((st) => ({
                                ...st,
                                switchAccountsModal: true,
                              }))
                            }
                          >
                            Change Account
                          </Menu.Item>
                        )}
                      {["CA", "CL"].includes(roleKey) &&
                        props?.user?.isConfig && (
                          <Menu.Item
                            key="4"
                            className="nav-item-dropdown"
                            onClick={() =>
                              setState((st) => ({
                                ...st,
                                switchDepartmentsModal: true,
                              }))
                            }
                          >
                            Change Department
                          </Menu.Item>
                        )}
                      <Menu.Item
                        key="5"
                        className="nav-item-dropdown logout"
                        onClick={logOut}
                      >
                        Logout
                      </Menu.Item>
                    </Menu>
                  }
                >
                  <div>
                    <ArrowDown className="chevron-down" />
                    <section className="profile-button">
                      <div className="user-initials">{initials}</div>
                    </section>
                  </div>
                </Dropdown>
              </>
            )}
          </section>
        </section>
      </nav>
    </>
  );
};

const mapStateToProps = (state) => ({
  patients: state.patients,
  user: state.login.user,
  popupReducer: state.popupReducer,
  unreadReducer: state.unreadReducer,
  notificationAlert: state.notificationAlert,
});

const mapDispatchToProps = (dispatch) => {
  return {
    LoginSagaAction: (data) => {
      dispatch(LoginSagaAction(data));
    },
    checkUserExist: (data) => dispatch(checkUserExist(data)),
    setPopup: (data) => dispatch(setPopup(data)),
    setUnread: (data) => dispatch(setUnread(data)),
    setNotificationAlert: (data) => dispatch(setNotificationAlert(data)),
    NotificationCount: bindActionCreators(notificationCountAction, dispatch),
    emptyReducerAction: bindActionCreators(emptyReducerAction, dispatch),
    PatientCount: () => dispatch(PatientCountAction()),
    activePatientSagaAction: bindActionCreators(
      activePatientSagaAction,
      dispatch
    ),
    liveAgentChatCount: bindActionCreators(liveAgentChatCountAction, dispatch),
    liveAgentChatSaga: bindActionCreators(liveAgentChatSagaAction, dispatch),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Header)
);
